import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Container, Button, Form, FormGroup, Input } from 'reactstrap';
import { registerEvent } from '../../redux/actions/UserActions'

class Register extends Component {
  state = { location: '' }

  handleChange = (e) => {
      this.setState({
          [e.target.id]: e.target.value
      })
  }

  handleSubmit = (role) => {
      console.log(this.props)
      var info = this.state;
      info['role'] = role;
      info['eventID'] = this.props.event.id;
      info['eventName'] = this.props.event.title;
      this.props.registerEvent(this.state);
  }

  render() {
    return (
      <div>
        <h3>Register</h3>
        <Form>
        <FormGroup>
            <Input type='text' name='location' id='location'
                   placeholder="Pickup location" onChange={this.handleChange} />
        </FormGroup>
        <div className='text-center'>
            <Button color='primary' block onClick={() => this.handleSubmit('Driver')}>Drive</Button>
            <Button color='success' block onClick={() => this.handleSubmit('Rider')}>Request Ride</Button>
        </div>
        </Form>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
      registerEvent: (info) => dispatch(registerEvent(info))
  }
}

export default connect(null, mapDispatchToProps)(Register)